// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"425":"597c6bf4c221de35","665":"597c6bf4c221de35"}[chunkId] + ".css";
};